<div class="cnae-modal-content fd-modal-content">
<h3 fxLayoutAlign="center">Editar CNAE</h3>
<div fxLayout="row" fxLayoutAlign="center">
    <div fxLayoutGap="20px" fxLayoutAlign="center" class="filter-container">
        <div fxFlex="39">
            <fd-institution (institutionSelected)="changeSelectedInstitution($event)" [formGroup]="formGroup"
                [field]="fields.institution">
            </fd-institution>
        </div>
        <div fxFlex="39">
            <fd-service-contract [formGroup]="formGroup" [field]="fields.serviceContract"
                [institution]="selectedInstitution">
            </fd-service-contract>
        </div>
    </div>
</div>

<form [formGroup]="formGroup">
    <div fxLayout="row" fxLayoutAlign="center">
        <div fxLayoutGap="20px" fxLayoutAlign="center" class="filter-container">
            <div fxFlex="80">
                <fd-select [parentForm]="formGroup" [field]="fields.cnae">
                </fd-select>
            </div>
        </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="center">
        <div fxLayoutGap="20px" fxLayoutAlign="center" class="filter-container">
            <div fxFlex="22">
                MDR Flex?
                            <mat-slide-toggle formControlName="mdrFlexAllowed" (change)="toggleChange($event)">
                                {{checkToggle(formGroup.value.mdrFlexAllowed)}}
                            </mat-slide-toggle>
            </div>
            <div fxFlex="22">
                Antecipação?
                        <mat-slide-toggle formControlName="prepaymentAllowed" (change)="toggleChange($event)">
                            {{checkToggle(formGroup.value.prepaymentAllowed)}}
                        </mat-slide-toggle>
            </div>
            <div fxFlex="22">
                Cartão estrangeiro?
                <mat-slide-toggle 
                    formControlName="ableForeignCard" 
                    (change)="cardToggleChange($event)">
                    {{checkToggle(formGroup.value.ableForeignCard)}}
                </mat-slide-toggle>
            </div>
            <div fxFlex="22">
                Em qual tecnologia?
                <div fxLayoutGap="20px">
                    <div>
                      <ng-container *ngFor="let item of technologiesTypeOptions">
                        <div>
                          <mat-checkbox 
                            (change)="onCheckboxChange(item, $event)"                    
                            [disabled]="techDisabled"
                            [value]="item.value" 
                            [checked]="item.selected" 
                            class="fd-checkbox">
                            {{item.label}}
                          </mat-checkbox>
                        </div>
                      </ng-container>
                    </div>
                  </div>
            </div>

        </div></div>
    <div mat-dialog-actions>
        <div class="value-edit-table__button-container">
            <fd-button mat-button fdSecondaryLarge [content]="'Cancelar'" (trigger)="close()"> </fd-button>
            <fd-button fdPrimaryLarge mat-flat-button [content]="'Salvar'" (trigger)="save()">
            </fd-button>
        </div>
    </div>
</form>
</div>